import React, { useRef, useEffect, useContext } from 'react';
import styles from "../../../styles/components/UI/Custom/ConfirmationModal.module.css"
import { ThemeContext } from "../../../context/ThemeContext";

export const ConfirmationModal = ({
    isOpen,
    onClose,
    onConfirm,
    title = "Подтвердите действие",
    message = "Вы уверены, что хотите выполнить это действие?",
    confirmText = "Подтвердить",
    cancelText = "Отмена",
}) => {
    const modalRef = useRef(null);
    const { theme } = useContext(ThemeContext);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div className={styles.modalOverlay}>
            <div className={`${styles.modalContent} ${theme === 'dark' ? styles.darkModalContent : ''}`} ref={modalRef}>
                <h3 className={`${styles.modalHeader} ${theme === 'dark' ? styles.darkModalHeader : ''}`}>
                    {title}
                </h3>
                
                <p className={`${styles.modalMessage} ${theme === 'dark' ? styles.darkModalMessage : ''}`}>{message}</p>
                
                <div className={styles.actionButtons}>
                    <button 
                        onClick={onClose} 
                        className={`${styles.baseButton} ${styles.cancelButton} ${theme === 'dark' ? styles.darkCancelButton : ''}`}
                    >
                        {cancelText}
                    </button>
                    <button 
                        onClick={onConfirm} 
                        className={`${styles.baseButton} ${styles.confirmButton} ${theme === 'dark' ? styles.darkConfirmButton : ''}`}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};